module.exports = __webpack_public_path__ + "img/product-logo.576bc96f.svg";